import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { styles } from "../utils/styles";

const FormDialog = ({
  children,
  open,
  onClose,
  title,
  handleSubmit,
  handleBack,
  disabledSubmit = false, 
  loading,
  variant = "contained",
  maxWidth = "lg",
  scroll = "paper",
  sx = {},
  showActions = true,
  submitLabel = "Submit",
}) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={maxWidth}
      scroll={scroll}
    >
      <DialogTitle sx={{ px: 2, py: 1}}>
        <Box sx={styles.flexBetween}>
          {title}
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ ...sx }}>{children}</DialogContent>
      {showActions && (
        <DialogActions>
          {handleBack && (
            <LoadingButton
              onClick={handleBack}
              variant="outlined"
              disabled={loading}
            >
              Back
            </LoadingButton>
          )}
          <LoadingButton
            onClick={handleSubmit}
            variant={variant}
            loading={loading}
            disabled={loading || disabledSubmit} 
            sx={{ ...styles.customButton, mr: 1 }}
          >
            {submitLabel}
          </LoadingButton>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default FormDialog;
